import React from 'react';

const VueIcon = () => {
  return <img src='/skill-icons/vue.png' alt='vue-logo' />;
};

export default VueIcon;
